import { AppRoutes } from '@core-types/app-routes.type';

const PLANOGRAM_PAGE_CHILDREN: AppRoutes = [
  {
    path: '',
    redirectTo: 'constructor',
    pathMatch: 'full',
  },
  {
    path: 'items',
    loadComponent: () =>
      import('./edit-planogram/planogram-products/planogram-products').then((m) => m.PlanogramProducts),
  },
  {
    path: 'constructor',
    loadComponent: () =>
      import('./edit-planogram/planogram-constructor/planogram-constructor').then((m) => m.PlanogramConstructor),
  },
];

export const PLANOGRAM_ROUTES: AppRoutes = [
  {
    path: '',
    title: '2_0.NAVIGATION.planograms',
    loadComponent: () => import('@layouts/page-with-header/page-with-header').then((m) => m.PageWithHeader),
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () => import('./planogram-list/planogram-list').then((m) => m.PlanogramList),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./planogram-list/planogram-table/planogram-table').then((m) => m.PlanogramTable),
          },
          {
            path: 'realogram',
            loadComponent: () =>
              import('./planogram-list/realogram-table/realogram-table').then((m) => m.RealogramTable),
          },
        ],
      },
    ],
  },
  {
    path: '',
    title: '2_0.NAVIGATION.planograms',
    loadComponent: () => import('@layouts/page-full-size/page-full-size').then((m) => m.PageFullSize),
    children: [
      {
        path: 'create',
        loadComponent: () => import('./edit-planogram/edit-planogram').then((m) => m.EditPlanogram),
        data: {
          showBackBtn: true,
          title: '2_0.BTNS.new_planogram',
        },
        children: PLANOGRAM_PAGE_CHILDREN,
      },
      {
        path: ':id',
        loadComponent: () => import('./edit-planogram/edit-planogram').then((m) => m.EditPlanogram),
        data: {
          showBackBtn: true,
        },
        children: PLANOGRAM_PAGE_CHILDREN,
      },
    ],
  },
];
